
import Vue from "vue";
import { NewAlertDestinationsApiFunc, setAccessToken } from "@/api";
import { AlertDestination } from "@/models";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";

export type DataType = {
  alertDestination?: AlertDestination;
};

export default Vue.extend({
  name: "AlertDestinationDetailScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    BaseSubmitButton,
    BaseCancelButton,
  },

  data(): DataType {
    return {
      alertDestination: new AlertDestination(),
    };
  },

  computed: {
    name(): string {
      return this.alertDestination?.name || "";
    },

    mailAddress(): string {
      return this.alertDestination?.mailAddress || "";
    },

    enabledAlertsText(): string {
      const enabledAlerts = [];
      if (this.alertDestination?.longStayAlertEnabled) {
        enabledAlerts.push("長時間利用通知");
      }
      if (this.alertDestination?.lowBatteryAlertEnabled) {
        enabledAlerts.push("電池残量通知");
      }
      if (this.alertDestination?.failureAlertEnabled) {
        enabledAlerts.push("機器停止通知");
      }
      return enabledAlerts.join(" / ");
    },
  },

  mounted() {
    this.getAlertDestination();
  },

  methods: {
    async getAlertDestination(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const alertDestinationId = this.$router.currentRoute.params.alertDestinationId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewAlertDestinationsApiFunc().getAlertDestination(companyId, alertDestinationId);

      if (err != null) {
        this.$handleApiError(err, this.getAlertDestination);
        return;
      }

      this.alertDestination = data;
    },

    async deleteAlertDestination(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);
      const alertDestinationId = this.$router.currentRoute.params.alertDestinationId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewAlertDestinationsApiFunc().deleteAlertDestination(companyId, alertDestinationId);

      if (err != null) {
        this.$handleApiError(err, this.deleteAlertDestination);
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-alert-destinations",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
